import { TokenValue } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';

// Check if a string value is a valid CSS color via the browser's parser,
// with a regex fallback for environments without CSS.supports
function isColorValue(value: string): boolean {
	const trimmed = value.trim();
	if (!trimmed) return false;
	if (typeof CSS !== 'undefined' && CSS.supports) {
		return CSS.supports('color', trimmed);
	}
	const lower = trimmed.toLowerCase();
	if (/^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(lower)) return true;
	if (/^(rgba?|hsla?)\s*\(/.test(lower)) return true;
	return false;
}

// Resolves var() references and checks if the underlying value is a color
export function resolvesToColor(originalValue: string): boolean {
	return isColorValue(resolveTokenValue(originalValue));
}

// Strips var() wrapper, e.g. "var(--theme-blue-800)" -> "--theme-blue-800"
export function stripVar(value: string): string {
	return value.replace(/^var\(([^)]+)\)$/, '$1');
}

// Formats a token value for display
export function formatTokenValue(value: TokenValue): string {
	switch (value.kind) {
		case 'color':
			return value.hex;
		case 'length':
			return value.px !== undefined ? `${value.px}px` : value.original;
		case 'fontFamily':
			return value.families.join(', ');
		case 'fontSize':
			return value.length.original;
		case 'fontWeight':
			return value.keyword || String(value.numeric);
		case 'lineHeight':
			return value.original;
		case 'borderRadius':
			return value.length.original;
		case 'opacity':
			return `${Math.round(value.value * 100)}%`;
		case 'transition':
			return `${value.duration} ${value.timingFunction}`;
		case 'string':
			return stripVar(value.original);
		default:
			return stripVar(value.original);
	}
}
